import React from "react";

// Blog Component
const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      date: "22 Aug, 2020",
      title: "We have announced our new Wallabies Forced Air Warming System.",
      image: "/images/keyword/1.jpg", 
      description:
        "Wallabies Warm Care proudly introduces its innovative Forced Air Patient Warming System, designed for optimal patient comfort and safety during medical treatments. This system uses cutting-edge technology to ensure quick and effective body temperature management.",
      link: "blog-single.html",
    },
    {
      id: 2,
      date: "15 Jul, 2020",
      title: "Top 5 Benefits of Wallabies Forced Air Patient Warming Unit.",
      image: "/images/keyword/4.jpg",
      description:
        "The Wallabies Forced Air Patient Warming Unit offers exceptional benefits for patient care. With a slim and lightweight design, it provides fast and efficient warming, ensuring patients remain comfortable throughout medical procedures. Here are 5 benefits you should know about.",
      link: "blog-single.html",
    },
    {
      id: 3,
      date: "05 Jan, 2020",
      title: "Why Wallabies Forced Air Warming Blanket is Essential in Medical Settings.",
      image: "/images/keyword/3.jpg",
      description:
        "Wallabies Forced Air Warming Blanket is a critical tool in maintaining patient body temperature during surgeries and medical procedures. Discover how this simple yet highly effective device plays a vital role in patient care and safety.",
      link: "blog-single.html",
    },
  ];

  return (
    <section className="blog section py-5" id="blog" style={{backgroundColor:'#D3E3FD'}}>
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-12 text-center">
            <div className="section-title">
              <h2 className="display-4 font-weight-bold ">
                Keep up with Our Most Recent Medical News.
              </h2>
              <img src="img/section-img.png" alt="Section Image" className="img-fluid my-4" />
              <p className="lead text-muted">
                Stay informed about the latest advancements in patient care with Wallabies Warm Care products, designed to prioritize comfort and safety.
              </p>
            </div>
          </div>
        </div>
        
        {/* Blog Posts */}
        <div className="row">
          {blogPosts.map((post) => (
            <div key={post.id} className="col-lg-4 col-md-6 col-12 mb-4 bg-bluee">
              {/* Single Blog */}
              <div className="single-news bg-white shadow-lg rounded p-4 h-100">
                <div className="news-head">
                  <img src={post.image} alt={post.title} className="img-fluid rounded mb-3" />
                </div>
                <div className="news-body">
                  <div className="news-content">
                    <h3 className="h5 font-weight-bold text-dark">
                      <a href={post.link} className="whycolor text-decoration-none">
                        {post.title}
                      </a>
                    </h3>
                    <p className="text-muted">{post.description}</p>
                  </div>
                </div>
              </div>
              {/* End Single Blog */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
